import {COMETA_CLICK_ENERGY} from '../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {FederatedPointerEvent} from 'pixi.js';

import {injected} from 'brandi';

import {BaseComponent, IGameWorld} from '@specials/gcs-engine';

import {GameOperationsService} from '@/services/shared/GameOperationsService/GameOperationsService';
import {ClickerStateStore} from '@/stores/ClickerStateStore/ClickerStateStore';
import {GameStatusStore} from '@/stores/GameStatusStore/GameStatusStore';

import {PointsEmitter} from '../PointsEmitterPool/PointsEmitter';
import {CometaViewComponent} from './CometaViewComponent';

export type CometaType = 1 | 2 | 3 | 4;

export class CometaDataComponent extends BaseComponent {
  public cometaType: CometaType;
  public rotationSpeed: number;
  private pointsEmitter?: PointsEmitter;
  private viewComponent?: CometaViewComponent;

  constructor(
    private readonly gameOperationsService: GameOperationsService,
    private readonly clickerStateStore: ClickerStateStore,
    private readonly gameStatusStore: GameStatusStore,
  ) {
    super();
  }

  public onAddToWorld(world: IGameWorld): void {
    this.pointsEmitter = world.getGameObject(PointsEmitter);
    this.viewComponent = this.gameObject.getComponent(CometaViewComponent);
  }

  public isInteractiveDisabled(e: FederatedPointerEvent): boolean {
    if (!this.viewComponent) return true;
    if (!this.gameStatusStore.isStatusActive()) return false;

    return !this.clickerStateStore.isEnoughEnergyToSpend(COMETA_CLICK_ENERGY) || e.target !== this.viewComponent.view;
  }

  public handleClick = (e: FederatedPointerEvent): void => {
    if (this.gameStatusStore.isStatusActive() || this.gameStatusStore.isStatusGameMocks()) {
      this.gameOperationsService.pushSpendEnergyOperation(COMETA_CLICK_ENERGY);

      const points = this.clickerStateStore.getPointsByEnergy(COMETA_CLICK_ENERGY);
      this.pointsEmitter?.emitterComponent.spawnPoints(points, e.screen);
    }
  };
}

injected(CometaDataComponent, DI_TOKENS.gameOperationsService, DI_TOKENS.clickerStateStore, DI_TOKENS.gameStatusStore);
